<template>
  <header class="d-flex justify-content-between align-items-center"  style="background-color: #198754;">
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
      <ul id="menuList">
        <li :class="{ topmenuactive: activeTab === 'CoDong' }" @click="changeTab('CoDong')">
          <a id="urlCoDong" href="congty#CoDong/">{{
            currentLanguage.header_text_congTy_coDong
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'DoiTac' }" @click="changeTab('DoiTac')" style="display: none;">
          <a id="urlDoiTac" href="congty#DoiTac/">{{
            currentLanguage.header_text_khachHang_doiTac
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'HoiDongQuanTri' }" @click="changeTab('HoiDongQuanTri')" style="display: none;">
          <a id="urlHoiDongQuanTri" href="congty#HoiDongQuanTri/">{{
            currentLanguage.header_text_congTy_hoiDongQuanTri
          }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'BanDieuHanh' }" @click="changeTab('BanDieuHanh')" style="display: none;">
          <a id="urlBanDieuHanh" href="congty#BanDieuHanh/">{{ currentLanguage.header_text_congTy_banDieuHanh }}
          </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'BanKiemSoat' }" @click="changeTab('BanKiemSoat')" style="display: none;">
          <a id="urlBanKiemSoat" href="congty#BanKiemSoat/">{{
            currentLanguage.header_text_congTy_banKiemSoat
          }}</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'NhomTuVan' }" @click="changeTab('NhomTuVan')" style="display: none;">
          <a id="urlNhomTuVan" href="congty#NhomTuVan/">
            {{ currentLanguage.header_text_congTy_NhomTuVan || "Nhóm tư vấn" }}
          </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'QuyetDinh' }" @click="changeTab('QuyetDinh')" 
          style="display: none;">
          <a id="urlQuyetDinh" href="congty#QuyetDinh/">
            {{ currentLanguage.header_text_congTy_quyetDinh || "Quyết định" }}
          </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'QuyDinh' }" @click="changeTab('QuyDinh')" style="display: none;">
          <a id="urlQuyDinh" href="congty#quydinh/">
            {{ currentLanguage.header_text_QuyDinh || "Quy định" }}
          </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'LienHe' }" @click="changeTab('LienHe')">
          <a id="urlLienHe" href="congty#LienHe/">{{
            currentLanguage.header_text_lienHe
          }}</a>
        </li>
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <div class="menu_co_right" style="display: flex">
         <a @click="changeLanguage('hu')" class="lang" style="padding: 5px"><img
            src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1774504537907WeDTF"  style="width: 25px;"/>
        </a>
        <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
            src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>
        <a @click="changeLanguage('ja')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
            src="img/img-item-vimass-2022/co/ja.jpg" />
        </a>

        <span class="clickShow" style="color: #303038; cursor: pointer; margin: auto"><i class="fa fa-ellipsis-h"
            aria-hidden="true"></i></span>
      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>
  </header>
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <!-- thi diem -->
      <div id="DoiTac" v-show="showDoiTac" style="min-height: 500px" class="padding-top15">
        <DoiTac></DoiTac>
      </div>
      <!-- tai tro-->
      <div id="CoDong" v-show="showCoDong" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <CoDongVue></CoDongVue>
      </div>
      <!-- Giao Duc -->
      <div id="HoiDongQuanTri" v-show="showHoiDongQuanTri" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <HoiDongQuanTriVue></HoiDongQuanTriVue>
      </div>
      <!-- suc khoe -->
      <div id="BanKiemSoat" v-show="showBanKiemSoat" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <BanKiemSoatVue></BanKiemSoatVue>
      </div>
      <!-- BanDieuHanh -->
      <div id="BanDieuHanh" v-show="showGiaoThongDVC" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <BanDieuHanhVue></BanDieuHanhVue>
      </div>
      <!-- ngan hang -->
      <div id="LienHe" v-show="showLienHe" style="min-height: 500px; background-image: none !important">
        <!-- <div class="title-bai-viet" v-html="titleLienHe"></div> -->
        <div v-html="contentLienHe"></div>
      </div>
      <div id="QuyetDinh" v-show="showQuyetDinh" style="min-height: 500px" class="padding-top15">
        <QuyetDinhVue></QuyetDinhVue>
      </div>
      <div id="QuyDinh" v-show="showQuyDinh" style="min-height: 500px" class="padding-top15">
        <QuyDinh></QuyDinh>
      </div>

      <div id="NhomTuVan" v-show="showNhomTuVan" style="min-height: 500px; background-image: none !important"
        class="padding-top15">
        <!-- <div class="title-bai-viet" v-html="titleNhomTuVan"></div>  -->
        <div v-html="contentNhomTuVan"></div>
      </div>
    </main>
  </div>
  <FooterView></FooterView>
</template>
<script>
import FooterView from "../FooterView/FooterView.vue";
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";
import DoiTac from "@/views/8_View_Layer/MainBaiVietCon/CongTy/DoiTac.vue";
import CoDongVue from "../MainCon/CoDong.vue";
import HoiDongQuanTriVue from "@/views/8_View_Layer/MainBaiVietCon/CongTy/HoiDongQuanTri.vue";
import BanKiemSoatVue from "@/views/8_View_Layer/MainBaiVietCon/CongTy/BanKiemSoat.vue";
import BanDieuHanhVue from "@/views/8_View_Layer/MainBaiVietCon/CongTy/BanDieuHanh.vue";
import QuyetDinhVue from "@/views/8_View_Layer/MainBaiVietCon/CongTy/QuyetDinh.vue";
import NhomTuVan from "@/views/8_View_Layer/MainBaiVietCon/CongTy/NhomTuVan.vue";
import QuyDinh from "@/views/8_View_Layer/MainBaiVietCon/CongTy/QuyDinh.vue";

export default {
  components: {
    BanDieuHanhVue,
    BanKiemSoatVue,
    HoiDongQuanTriVue,
    CoDongVue,
    DoiTac,
    FooterView, QuyDinh,
    // eslint-disable-next-line vue/no-unused-components
    QuyetDinhVue, NhomTuVan
  },
  data() {
    return {
      activeTab: "CoDong",
      isMenuVisible: false,
      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      //show
      showDoiTac: false,
      showCoDong: true,
      showHoiDongQuanTri: false,
      showBanKiemSoat: false,
      showGiaoThongDVC: false,
      showLienHe: false,

      //active tab
      isActiveDoiTac: false,
      isActiveCoDong: true,
      isActiveHoiDongQuanTri: false,
      isAcitveBanKiemSoat: false,
      isActiveGiaoThongDVC: false,
      isActiveLienHe: false,
      showQuyetDinh: false,
      isActiveQuyetDinh: false,

      showQuyDinh: false,
      isActiveQuyDinh: false,
      //title
      showNhomTuVan: false,
      isActiveNhomTuVan: false,
      titleLienHe: "",

      //content

      contentLienHe: "",

      titleNhomTuVan: "",
      contentNhomTuVan: "",

      hasMounted: false,
    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true; // Set the flag to true to indicate that mounted has been executed
      this.lang = localStorage.getItem("languages") || "vi";
      if (this.lang == "vi") {
        document.title = "Vimass.vn - Công ty";
      } else if (this.lang == "en") {
        document.title = "Vimass.vn - Company";
      } else if (this.lang == "cn") {
        document.title = "Vimass.vn - 公司";
      } else if (this.lang == "kr") {
        document.title = "Vimass.vn - 회사";
      }
      // window.location.href = this.lang + "/congty#doitac/";
      document.getElementById("urlHome").setAttribute("href", this.lang);
      document
        .getElementById("urlDoiTac")
        .setAttribute("href", this.lang + "/congty#doitac/");
      document
        .getElementById("urlCoDong")
        .setAttribute("href", this.lang + "/congty#codong/");
      document
        .getElementById("urlHoiDongQuanTri")
        .setAttribute("href", this.lang + "/congty#hoidongquantri/");
      document
        .getElementById("urlBanKiemSoat")
        .setAttribute("href", this.lang + "/congty#bankiemsoat/");
      document
        .getElementById("urlBanDieuHanh")
        .setAttribute("href", this.lang + "/congty#bandieuhanh/");
      document
        .getElementById("urlLienHe")
        .setAttribute("href", this.lang + "/congty#lienhe/");
      document
        .getElementById("urlQuyetDinh")
        .setAttribute("href", this.lang + "/congty#quyetdinh/");
      document
        .getElementById("urlNhomTuVan")
        .setAttribute("href", this.lang + "/congty#nhomtuvan/");
      document
        .getElementById("urlQuyDinh")
        .setAttribute("href", this.lang + "/congty#quydinh/");

      const hash = window.location.hash;
      if (hash && hash.includes("#codong")) {
        this.changeTab("CoDong");
      } else if (hash && hash.includes("#hoidongquantri")) {
        this.changeTab("HoiDongQuanTri");
      } else if (hash && hash.includes("#bankiemsoat")) {
        this.changeTab("BanKiemSoat");
      } else if (hash && hash.includes("#bandieuhanh")) {
        // this.changeTab("taitro");
        this.changeTab("BanDieuHanh");
      } else if (hash && hash.includes("#quyetdinh")) {
        this.changeTab("QuyetDinh");
      } else if (hash && hash.includes("#lienhe")) {
        this.changeTab("LienHe");
      } else if (hash && hash.includes("#nhomtuvan")) {
        this.changeTab("NhomTuVan");
      } else if (hash && hash.includes("#doitac")) {
        this.changeTab("DoiTac");
      } else if (hash && hash.includes("#quydinh")) {
        this.changeTab("QuyDinh");
      } else {
        this.changeTab("CoDong");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      const langReload = localStorage.getItem("languages");
      window.location.href =
        "/" + langReload + "/congty" + window.location.hash;
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store content separately for each section
        if (section === "LienHe") {
          this.titleLienHe = decodeURIComponent(escape(title));
          this.contentLienHe = decodeURIComponent(escape(decodedString));
        } else if (section === "NhomTuVan") {
          this.titleNhomTuVan = decodeURIComponent(escape(title));
          this.contentNhomTuVan = decodeURIComponent(escape(decodedString));

        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    changeTab(tab) {
      if (window.innerWidth <= 768) {
        this.isMenuVisible = false;
      }
      this.lang = localStorage.getItem("languages") || "vi";

      if (tab === "DoiTac") {
        this.isActiveDoiTac = true;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
        this.isActiveLienHe = false;
      } else if (tab === "CoDong") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = true;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
        this.isActiveLienHe = false;
      } else if (tab === "HoiDongQuanTri") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = true;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
        this.isActiveLienHe = false;
      } else if (tab === "BanKiemSoat") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = true;
        this.isActiveGiaoThongDVC = false;
        this.isActiveLienHe = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
        this.isActiveQuyetDinh = false;
      } else if (tab === "BanDieuHanh") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = true;
        this.isActiveLienHe = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
      } else if (tab === "LienHe") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveLienHe = true;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
        this.performPostRequest("1690272053288yg3c7", "LienHe", this.lang);
      } else if (tab === "QuyetDinh") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveLienHe = false;
        this.isActiveQuyetDinh = true;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = false;
      } else if (tab === "NhomTuVan") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveLienHe = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = true; this.showQuyDinh = false;
        this.performPostRequest("1763806311682OoLhD", "NhomTuVan", this.lang);

      }
      else if (tab === "QuyDinh") {
        this.isActiveDoiTac = false;
        this.isActiveCoDong = false;
        this.isActiveHoiDongQuanTri = false;
        this.isAcitveBanKiemSoat = false;
        this.isActiveGiaoThongDVC = false;
        this.isActiveLienHe = false;
        this.isActiveQuyetDinh = false;
        this.isActiveNhomTuVan = false;
        this.showQuyDinh = true;
      }

      this.activeTab = tab; // Cập nhật giá trị activeTab

      this.showDoiTac = tab === "DoiTac";
      this.showCoDong = tab === "CoDong";
      this.showHoiDongQuanTri = tab === "HoiDongQuanTri";
      this.showBanKiemSoat = tab === "BanKiemSoat";
      this.showGiaoThongDVC = tab === "BanDieuHanh";
      this.showLienHe = tab == "LienHe";
      this.showQuyetDinh = tab === "QuyetDinh";
      this.showNhomTuVan = tab === "NhomTuVan";
      this.showQuyDinh = tab === "QuyDinh";
    },
  },
};
</script>
<style scoped>
.topmenuactive {
    /* border-bottom: 5px solid red; */
    background: #68b362 !important;
    color: #ffffff !important;
}</style>
